module.exports = __webpack_public_path__ + "static/img/1073_small.59afbf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1073_small.png
// module id = LOHC
// module chunks = 1